import { env } from '@/config/env-schema'
import { faro } from '@grafana/faro-react'

export const reportError = (error: Error) => {
  if (env.CLIENT_VAR__APP_ENV === 'local') {
    // Grafana is not enabled in local environment
    console.error('Reporting error:', error)
  } else {
    faro.api.pushError(error)
  }
}
